import Webcam from "react-webcam";
import { useGeolocated } from "react-geolocated";
import piexif from "piexifjs";
import { isMobile } from "react-device-detect";

import { useRef, useState, useCallback } from "react"; // import useRef
import PropTypes from "prop-types";
import {
  Grid,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import MDButton from "theme/components/MDButton";
import AppConfig from "appConfig";

function GeoTaggedImageField({ displayName, fieldRef, isOptional, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const webcamRef = useRef(`${fieldRef}_${displayName}`); // create a webcam reference
  const [imgSrc, setImgSrc] = useState(null);
  const [capturedData, setCapturedData] = useState(null);
  const [cameraUsed, setCameraUsed] = useState(false);

  const placeholderImg =
    "data:image/jpeg;base64,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";

  const videoConstraints = {
    facingMode: cameraUsed ? "user" : { exact: "environment" },
  };

  const [openWebCamDialog, setOpenWebCamDialog] = useState(false);

  async function getGeocodeData(lat, lng) {
    const apiKey = AppConfig.google_map_key;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

    const response = await fetch(url);
    if (!response.ok) {
      return null;
    }
    const data = await response.json();
    let formatted_address = null;
    if (data.results.length > 0) {
      formatted_address = data.results[0].formatted_address;
    }

    return formatted_address;
  }

  function getHaversineDistance(lat1, lon1, lat2, lon2) {
    const R = 6371e3; // Earth's radius in meters (or 3959 for miles)
    const φ1 = (lat1 * Math.PI) / 180; // Latitude 1 in radians
    const φ2 = (lat2 * Math.PI) / 180; // Latitude 2 in radians
    const Δφ = ((lat2 - lat1) * Math.PI) / 180; // Difference in latitude in radians
    const Δλ = ((lon2 - lon1) * Math.PI) / 180; // Difference in longitude in radians

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const d = R * c; // Distance in meters (or miles if R is in miles)
    return d;
  }

  // async function addWatermark(base64, text) {
  //   // Load image
  //   const img = await new Promise((resolve, reject) => {
  //     const i = new Image();
  //     i.onload = () => resolve(i);
  //     i.onerror = reject;
  //     i.src = base64;
  //   });

  //   const canvas = document.createElement("canvas");
  //   const ctx = canvas.getContext("2d");
  //   canvas.width = img.width;
  //   canvas.height = img.height;

  //   // Draw the original image
  //   ctx.drawImage(img, 0, 0);

  //   // Split text into lines
  //   const lines = text.split(/\r?\n/);

  //   // Text settings
  //   const fontSize = Math.round(img.width * (isMobile ? 0.05 : 0.03)); // ~3% of image width
  //   const lineHeight = fontSize * 1.3;
  //   ctx.font = isMobile ? `bold ${fontSize}px Arial` : `${fontSize}px Arial`;
  //   ctx.textBaseline = "top";

  //   // Measure widest line
  //   const textWidths = lines.map((line) => ctx.measureText(line).width);
  //   const textWidth = Math.max(...textWidths);
  //   const textHeight = lines.length * lineHeight;

  //   // Position and padding
  //   const padding = 10;
  //   const x = img.width - textWidth - padding * 2;
  //   const y = img.height - textHeight - padding * 2;

  //   // Background rectangle
  //   ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
  //   ctx.fillRect(x - padding, y - padding, textWidth + padding * 2, textHeight + padding * 2);

  //   // Draw text
  //   ctx.fillStyle = "#fff";
  //   lines.forEach((line, i) => {
  //     ctx.fillText(line, x, y + i * lineHeight);
  //   });

  //   // Return JPEG base64 (quality 0.92)
  //   return canvas.toDataURL("image/jpeg", 0.92);
  // }

  async function addWatermark(base64, text) {
    // Load image as Promise
    const img = await new Promise((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = reject;
      i.src = base64;
    });

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = img.width;
    canvas.height = img.height;

    // Draw image
    ctx.drawImage(img, 0, 0);

    // Settings
    const fontSize = Math.round(img.width * (isMobile ? 0.05 : 0.03)); // ~3% of image width
    const lineHeight = fontSize * 1.3;
    ctx.font = `${fontSize}px Arial`;
    ctx.textBaseline = "top";

    // Split text into lines and wrap long ones
    const maxWidth = img.width * 0.9; // 90% of image width
    const paragraphs = text.split(/\r?\n/);
    const wrappedLines = [];

    for (const para of paragraphs) {
      const words = para.split(" ");
      let line = "";

      for (const word of words) {
        const testLine = line ? `${line} ${word}` : word;
        const testWidth = ctx.measureText(testLine).width;
        if (testWidth > maxWidth) {
          wrappedLines.push(line);
          line = word;
        } else {
          line = testLine;
        }
      }
      if (line) wrappedLines.push(line);
    }

    // Measure text box
    const textWidths = wrappedLines.map((l) => ctx.measureText(l).width);
    const textWidth = Math.max(...textWidths);
    const textHeight = wrappedLines.length * lineHeight;

    // Padding and position (bottom-right)
    const padding = Math.round(fontSize * 0.4);
    const x = img.width - textWidth - padding * 2;
    const y = img.height - textHeight - padding * 2;

    // Background box
    ctx.fillStyle = "rgba(0,0,0,0.5)";
    ctx.fillRect(
      x - padding,
      y - padding,
      textWidth + padding * 2,
      textHeight + padding * 2
    );

    // Text color and draw
    ctx.fillStyle = "#fff";
    wrappedLines.forEach((line, i) => {
      ctx.fillText(line, x, y + i * lineHeight);
    });

    // Return JPEG
    return canvas.toDataURL("image/jpeg", 0.92);
  }

  async function geoTagImage(imageSrc, lat, lng, meta) {
    if (!imageSrc) return;

    var m = 1000000;
    var xlat = lat * m;
    var xlng = lng * m;
    var ts = new Date().toISOString();

    var formatted_address = await getGeocodeData(lat, lng);
    var faddr = formatted_address ? `\n${formatted_address}` : "";
    var gpsText = `GeoTagged Image\n${faddr}\n${lat}, ${lng}\n${ts}\nLaddar Africa`;
    var watermarkedImg = await addWatermark(imageSrc, gpsText);

    const zeroth = {};
    zeroth[piexif.ImageIFD.Make] = "Laddar.Africa";
    zeroth[piexif.ImageIFD.Model] = "Laddar Forms";
    zeroth[piexif.ImageIFD.Software] = "AgentApp_DataForm";

    const gps = {};
    gps[piexif.GPSIFD.GPSLatitudeRef] = lat > 0 ? "N" : "S";
    gps[piexif.GPSIFD.GPSLatitude] = [xlat, m];
    gps[piexif.GPSIFD.GPSLongitudeRef] = lng > 0 ? "E" : "W";
    gps[piexif.GPSIFD.GPSLongitude] = [xlng, m];

    const exif = {};
    exif[piexif.ExifIFD.DateTimeOriginal] = ts;
    exif[piexif.ExifIFD.UserComment] = meta;
    // zeroth[piexif.ImageIFD.ImageDescription] = "React Custom Metadata";

    // Combine EXIF data
    const exifObj = { "0th": zeroth, Exif: exif, GPS: gps };
    const exifStr = piexif.dump(exifObj);

    // Insert EXIF into image
    const newImage = piexif.insert(exifStr, watermarkedImg);

    // var exi = piexif.load(newImage);
    // console.log(exi);

    // Optional download
    // const a = document.createElement("a");
    // a.href = newImage;
    // a.download = "photo_with_custom_exif.jpg";
    // a.click();

    return newImage;
  }

  // create a capture function
  const capture = useCallback(
    async (gpsCoords) => {
      const imageSrc = webcamRef.current.getScreenshot();
      if (!imageSrc) {
        setErrorMsg("No photo image found.");
        showFieldError(true);
        return;
      }

      // Run validation checks if any
      if (
        typeof options.lat !== "undefined" &&
        typeof options.lng !== "undefined" &&
        typeof options.rad !== "undefined"
      ) {
        var dist = getHaversineDistance(
          parseFloat(options.lat),
          parseFloat(options.lng),
          parseFloat(gpsCoords.latitude).toFixed(6),
          parseFloat(gpsCoords.longitude).toFixed(6)
        );
        // console.log(dist);
        if (dist > parseFloat(options.rad)) {
          setErrorMsg("You are not within GPS location radius.");
          showFieldError(true);
          return;
        }
      }

      var taggedImgSrc = await geoTagImage(
        imageSrc,
        parseFloat(gpsCoords.latitude).toFixed(6),
        parseFloat(gpsCoords.longitude).toFixed(6),
        "Captured using Laddar Africa Data Forms. https://laddar.africa/"
      );
      if (!taggedImgSrc) {
        setErrorMsg(
          "Geo-tagging failed. Enable required browser perimssions and try again."
        );
        showFieldError(true);
        return;
      }

      const gpsData = {
        latitude: gpsCoords.latitude,
        longitude: gpsCoords.longitude,
        timestamp: new Date().toISOString(),
      };
      setCapturedData(JSON.stringify({ image: taggedImgSrc, gps: gpsData }));
      setImgSrc(taggedImgSrc);
      setOpenWebCamDialog(false);
    },
    [webcamRef]
  );

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
        // maximumAge: 0,
      },
      // watchPosition: true,
      userDecisionTimeout: 5000,
    });

  function getGPSCoords() {
    if (!isGeolocationAvailable) {
      return false;
    }

    if (!isGeolocationEnabled) {
      return false;
    }

    if (coords) {
      return { latitude: coords.latitude, longitude: coords.longitude };
    }
    return false;
  }

  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openWebCamDialog}>
        <DialogTitle>
          <Box>Take a picture</Box>
        </DialogTitle>
        <DialogContent>
          <Box mt={1} mb={3}>
            <Webcam
              // height={"100%"}
              width="100%"
              ref={webcamRef}
              screenshotQuality={1}
              videoConstraints={videoConstraints}
              screenshotFormat="image/jpeg"
              mirrored={cameraUsed ? true : false}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenWebCamDialog(false);
            }}
            color="primary"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </MDButton>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <MDButton
            onClick={() => {
              setCameraUsed(!cameraUsed);
            }}
            color="warning"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>cameraswitch</Icon>
          </MDButton>
          &nbsp;
          <MDButton
            color="info"
            variant="outlined"
            iconOnly
            circular
            onClick={() => {
              const gpsCoords = getGPSCoords();
              if (gpsCoords === false) {
                console.log(options);
                setErrorMsg(
                  "Unable to retrieve your current location. Make sure Location permissions are allowed on your browser."
                );
                showFieldError(true);
                return;
              }
              capture(gpsCoords);
            }}
          >
            <Icon>photo_camera</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <Box sx={{ minWidth: 120, width: "100%" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} md={6} lg={6}>
            <Typography variant="h6" fontWeight="light" fontSize="small" mb={2}>
              {displayName}
            </Typography>
          </Grid>
          <Grid item xs={6} md={6} lg={6}>
            <Box align="right">
              <IconButton
                color="primary"
                variant="contained"
                size="small"
                onClick={() => {
                  setOpenWebCamDialog(true);
                }}
                options={options}
              >
                <Icon>camera_alt</Icon>
              </IconButton>
              {capturedData && (
                <>
                  &nbsp;
                  <IconButton
                    color="primary"
                    variant="contained"
                    size="small"
                    onClick={() => {
                      setCapturedData(null);
                      setImgSrc(null);
                    }}
                    options={options}
                  >
                    <Icon>clear</Icon>
                  </IconButton>
                </>
              )}
            </Box>
          </Grid>
        </Grid>
        <Box>
          {imgSrc && (
            <div>
              <img src={imgSrc} alt="webcam" width="50%" />
              <Typography
                mt={1}
                variant="subtitle2"
                fontSize={14}
                fontWeight="light"
              >
                <small>
                  GPS: {coords.latitude.toFixed(6)},{" "}
                  {coords.longitude.toFixed(6)}
                  &nbsp;
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href={`https://maps.google.com?q=${coords.latitude},${coords.longitude}`}
                  >
                    [View On Map]
                  </a>
                </small>
              </Typography>
            </div>
          )}
        </Box>
      </Box>
      <input
        id={`dff_${fieldRef}`}
        type="hidden"
        name={fieldRef}
        value={capturedData}
      />
    </Box>
  );
}

// Typechecking props of the Transaction
GeoTaggedImageField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

GeoTaggedImageField.defaultProps = {
  options: null,
};

export default GeoTaggedImageField;
